import React from 'react'
import { Button, TextField } from '@material-ui/core';
import SerialManager from './SerialManager'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

class Example extends React.Component {
  constructor() {
    super()

    this._handleSendCommand = this._handleSendCommand.bind(this)
    
    this._handleTextFieldChange = this._handleTextFieldChange.bind(this)
    this._handleReadStateTextFieldChange = this._handleReadStateTextFieldChange.bind(this)
    this._handlePacketSizeTextFieldChange = this._handlePacketSizeTextFieldChange.bind(this)
    this._handlePacketDelayTextFieldChange = this._handlePacketDelayTextFieldChange.bind(this)

    this._handleConfigurationTextFieldChange = this._handleConfigurationTextFieldChange.bind(this)
    this._handleInterfaceTextFieldChange = this._handleInterfaceTextFieldChange.bind(this)
    
    this._handleConnectClick = this._handleConnectClick.bind(this)
    this._handleDisconnectClick = this._handleDisconnectClick.bind(this)
    this.onState = this.onState.bind(this)
    this.onConnect = this.onConnect.bind(this)
    this.onConnectError = this.onConnectError.bind(this)
    this.onDisconnect = this.onDisconnect.bind(this)
    this.onDisconnectError = this.onDisconnectError.bind(this)

    const eventHandlers = {
      onConnect: this.onConnect,
      onConnectError: this.onConnectError,
      onDisconnect: this.onDisconnect,
      onState: this.onState
    }

    this.serialManager = new SerialManager(eventHandlers)
    
    this.state = {
      command: 'G1 X90 Y45 Z60',
      printerState: "No state received yet...",
      connectionStatus: "DISCONNECTED",
      commandStatus: "Waiting for new command...",
      sentCommand: "No commands sent yet...",
      packetSize: "63",
      packetDelay: "20",
      readState: "TRUE",
      configuration: "1",
      interface: "0"
    }
    
    
  }

  _handleTextFieldChange(e) {
    this.setState({
      ...this.state, 
      command: e.target.value
    });
  }

  _handlePacketSizeTextFieldChange(e) {
    this.setState({
      ...this.state, 
      packetSize: e.target.value
    });
  }

  _handlePacketDelayTextFieldChange(e) {
    this.setState({
      ...this.state, 
      packetDelay: e.target.value
    });
  }

  _handleReadStateTextFieldChange(e) {
    this.setState({
      ...this.state, 
      readState: e.target.value
    });
  }

  _handleConfigurationTextFieldChange(e) {
    this.setState({
      ...this.state, 
      configuration: e.target.value
    });
  }

  _handleInterfaceTextFieldChange(e) {
    this.setState({
      ...this.state, 
      interface: e.target.value
    });
  }

  async _handleSendCommand() {
    this.setState({
      ...this.state, 
      commandStatus: "Sending....."
    });
      const sentCommand = await this.serialManager.sendCommand(this.state.command)
      this.setState({
        ...this.state, 
        sentCommand,
        commandStatus: "Waiting for new command"
      });
  }

  async _handleConnectClick() {
    this.setState({
      ...this.state, 
      connectionStatus: "CONNECTING"
    });

  
    if (this.state.readState === "TRUE") {
      
      this.serialManager.connect(parseInt(this.state.packetSize), parseInt(this.state.packetDelay), true, parseInt(this.state.configuration), parseInt(this.state.interface))   
    } else {
      this.serialManager.connect(parseInt(this.state.packetSize), parseInt(this.state.packetDelay), false, parseInt(this.state.configuration), parseInt(this.state.interface)) 
    }
    
  }

  async _handleDisconnectClick() {
    this.setState({
      ...this.state, 
      connectionStatus: "DISCONNECTING"
    });
    this.serialManager.disconnect()
  }

  onConnect(event){ 
    console.log(`[EVENT] ${event.type}`) 
    console.log(event.data)
    this.setState({
      ...this.state, 
      connectionStatus: "CONNECTED"
    });
  }

  onConnectError(event) { 
    console.log(`[EVENT] ${event.type}`) 
    console.log(event.data)
    this.setState({
      ...this.state, 
      connectionStatus: "CONNECT ERROR"
    });
  }

  onDisconnect(event){ 
    console.log(`[EVENT] ${event.type}`) 
    console.log(event.data)
    this.setState({
      ...this.state, 
      connectionStatus: "DISCONNECTED"
    });
  }
  
  onDisconnectError(event) { 
    console.log(`[EVENT] ${event.type}`) 
    console.log(event.data)
    this.setState({
      ...this.state, 
      connectionStatus: "DISCONNECT ERROR"
    });
  }

  onState(event) { 
    try {
      console.log(`[EVENT] ${event.type}`) 
      console.log(event.data)
      this.setState({
        ...this.state, 
        printerState:  JSON.stringify(event.data.state)
      });
    } catch (error) {
      this.setState({
        ...this.state, 
        printerState:  "Failed to process state"
      });
    
    }
    
    
  }

  render() {
    return (
      <div className="app">
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <Grid style={{ margin: "30px"}} container spacing={3}>
          <Grid item xs={12}>
              <TextField fullWidth={true} id="text-read-configuration" onChange={this._handleConfigurationTextFieldChange} label="Configuration" variant="outlined" value={this.state.configuration} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth={true} id="text-read-interface" onChange={this._handleInterfaceTextFieldChange} label="Interface" variant="outlined" value={this.state.interface} />
            </Grid>
          <Grid item xs={12}>
              <TextField fullWidth={true} id="text-read-state" onChange={this._handleReadStateTextFieldChange} label="Read State (TRUE or FALSE)" variant="outlined" value={this.state.readState} />
            </Grid>
          <Grid item xs={12}>
              <TextField fullWidth={true} id="text-packet-size" onChange={this._handlePacketSizeTextFieldChange} label="Packet Size (min 4)" variant="outlined" value={this.state.packetSize} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth={true} id="text-packet-delay" onChange={this._handlePacketDelayTextFieldChange} label="Delay between packets (milliseconds)" variant="outlined" value={this.state.packetDelay} />
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth={true} variant="contained" onClick={this._handleConnectClick}>Connect</Button>
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth={true} variant="contained" onClick={this._handleDisconnectClick}>Disconnect</Button>
            </Grid>
            <Grid item xs={12}>
              State: {this.state.connectionStatus}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
            <Grid style={{ margin: "30px"}} container spacing={3}>
              <Grid item xs={12}>
                <TextField fullWidth={true} id="outlined-basic" onChange={this._handleTextFieldChange} label="Command" variant="outlined" value={this.state.command} />
              </Grid>
              <Grid item xs={12}>
                <Button fullWidth={true} variant="contained" onClick={this._handleSendCommand}>Send Command</Button>
              </Grid>
              <Grid item xs={12}>
                Command Status: {this.state.commandStatus}
            </Grid>
              <Grid item xs={12}>
                Last command: {this.state.sentCommand}
            </Grid>
              <Grid item xs={12}>
                Printer State: {this.state.printerState}
            </Grid>
            
          </Grid>
        </Grid>
      </Grid>

    
        
      </div>
    )
  }
}

export default Example
